var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex xs12 md12" },
        [
          _c(
            "vuestic-widget",
            { attrs: { headerText: _vm.$t("tables.basic") } },
            [
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  { staticClass: "table table-striped first-td-padding" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.name"))
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.email"))
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.city"))
                          ),
                        ]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.score"))
                          ),
                        ]),
                        _c("td"),
                      ]),
                    ]),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [_vm._v("Matthew McCormick")]),
                        _c("td", [_vm._v("matthew30@mail.ol")]),
                        _c("td", [_vm._v("Vancouver")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("93")]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Nancy Bo")]),
                        _c("td", [_vm._v("nancy@boonweb.com")]),
                        _c("td", [_vm._v("Washington")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("280"),
                        ]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Frederiko Lopez")]),
                        _c("td", [_vm._v("fr.lopez@webmail.sp")]),
                        _c("td", [_vm._v("Barcelona")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("16")]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Stanley Hummer")]),
                        _c("td", [_vm._v("mr_winner_2999@gmail.cb")]),
                        _c("td", [_vm._v("Manchester")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("57")]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Lendley Wintz")]),
                        _c("td", [_vm._v("9938198146@mailster.io")]),
                        _c("td", [_vm._v("Wien")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("113"),
                        ]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Barbara Noz")]),
                        _c("td", [_vm._v("barbaranoz@mailster.io")]),
                        _c("td", [_vm._v("Brussels")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("68")]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Matthew McCormick")]),
                        _c("td", [_vm._v("matthew30@mail.ol")]),
                        _c("td", [_vm._v("Vancouver")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("93")]),
                        _c("td"),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Nancy Bo")]),
                        _c("td", [_vm._v("nancy@boonweb.com")]),
                        _c("td", [_vm._v("Washington")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("280"),
                        ]),
                        _c("td"),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c(
            "vuestic-widget",
            { attrs: { headerText: _vm.$t("tables.styled") } },
            [
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-striped table-sm color-icon-label-table",
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("td"),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.name"))
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.email"))
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.city"))
                          ),
                        ]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v(
                            _vm._s(_vm._f("translate")("tables.headings.score"))
                          ),
                        ]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                    ]),
                    _c("tbody", [
                      _c("tr", [
                        _c("td"),
                        _c("td", [_vm._v("Matthew McCormick")]),
                        _c("td", [_vm._v("matthew30@mail.ol")]),
                        _c("td", [_vm._v("Vancouver")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("93")]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                      _c("tr", [
                        _c("td"),
                        _c("td", [_vm._v("Nancy Bo")]),
                        _c("td", [_vm._v("nancy@boonweb.com")]),
                        _c("td", [_vm._v("Washington")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("280"),
                        ]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                      _c("tr", [
                        _c("td"),
                        _c("td", [_vm._v("Frederiko Lopez")]),
                        _c("td", [_vm._v("fr.lopez@webmail.sp")]),
                        _c("td", [_vm._v("Barcelona")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("16")]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                      _c("tr", { staticClass: "table-danger" }, [
                        _c("td", [
                          _c(
                            "span",
                            { staticClass: "badge badge-pill badge-danger" },
                            [_vm._v("DANGER")]
                          ),
                        ]),
                        _c("td", [_vm._v("Stanley Hummer")]),
                        _c("td", [_vm._v("mr_winner_2999@gmail.cb")]),
                        _c("td", [_vm._v("Manchester")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("57")]),
                        _c("td", { attrs: { align: "middle" } }, [
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle icon-right input-icon error-icon",
                          }),
                        ]),
                      ]),
                      _c("tr", { staticClass: "table-success" }, [
                        _c("td", [
                          _c(
                            "span",
                            { staticClass: "badge badge-pill badge-primary" },
                            [_vm._v("SUCCESS")]
                          ),
                        ]),
                        _c("td", [_vm._v("Lendley Wintz")]),
                        _c("td", [_vm._v("9938198146@mailster.io")]),
                        _c("td", [_vm._v("Wien")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("113"),
                        ]),
                        _c(
                          "td",
                          { staticClass: "valid", attrs: { align: "middle" } },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-check success-icon icon-right input-icon",
                            }),
                          ]
                        ),
                      ]),
                      _c("tr", { staticClass: "table-warning" }, [
                        _c("td", [
                          _c(
                            "span",
                            { staticClass: "badge badge-pill badge-warning" },
                            [_vm._v("WARNING")]
                          ),
                        ]),
                        _c("td", [_vm._v("Barbara Noz")]),
                        _c("td", [_vm._v("barbaranoz@mailster.io")]),
                        _c("td", [_vm._v("Brussels")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("68")]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                      _c("tr", [
                        _c("td"),
                        _c("td", [_vm._v("Matthew McCormick")]),
                        _c("td", [_vm._v("matthew30@mail.ol")]),
                        _c("td", [_vm._v("Vancouver")]),
                        _c("td", { attrs: { align: "right" } }, [_vm._v("93")]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                      _c("tr", { staticClass: "table-info" }, [
                        _c("td", [
                          _c(
                            "span",
                            { staticClass: "badge badge-pill badge-info" },
                            [_vm._v("INFO")]
                          ),
                        ]),
                        _c("td", [_vm._v("Nancy Bo")]),
                        _c("td", [_vm._v("nancy@boonweb.com")]),
                        _c("td", [_vm._v("Washington")]),
                        _c("td", { attrs: { align: "right" } }, [
                          _vm._v("280"),
                        ]),
                        _c("td", { attrs: { align: "middle" } }),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c(
            "vuestic-widget",
            { attrs: { headerText: _vm.$t("tables.advanced") } },
            [
              _c(
                "vuestic-data-table",
                {
                  attrs: {
                    apiUrl: _vm.apiUrl,
                    tableFields: _vm.tableFields,
                    itemsPerPage: _vm.itemsPerPage,
                    defaultPerPage: _vm.defaultTablePerPage,
                    sortFunctions: _vm.sortFunctions,
                    apiMode: _vm.apiMode,
                    paginationPath: _vm.paginationPath,
                    queryParams: _vm.queryParams,
                  },
                },
                [
                  _c("spring-spinner", {
                    attrs: {
                      slot: "loading",
                      "animation-duration": 2500,
                      size: 70,
                      color: "#4ae387",
                    },
                    slot: "loading",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }